import { useTranslation } from "react-i18next";
import { BaseThumbnail } from "../BaseThumbnail";
import styles from "./index.module.scss";

export interface ProcessingThumbnailProps {
    copy?: string;
}

export const ProcessingThumbnail = ({ copy }: ProcessingThumbnailProps) => {
    const { t } = useTranslation();
    return (
        <BaseThumbnail>
            <div className={styles["processing-wrapper"]}>
                <span key="processing" className={styles["processing"]}>
                    {copy || t("video-upload:video-processing-ellipsis")}
                </span>
            </div>
        </BaseThumbnail>
    );
};
